import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
type Review = {
  name: string;
  role: string;
  content: string;
  avatar: string | null;
  avatarPosition?: string;
};
const reviews: Review[] = [{
  name: 'Liliana Leal',
  role: 'Cliente Verificada',
  content: 'Altamente recomendado, servicio excepcional y con muy buena atencion, gracias a Eduardo y a su equipo mi credito esta excelente y buscando ya capital para mi negocio.',
  avatar: 'https://cdn.magicpatterns.com/uploads/hJXdKb1Zim1tL1u7PKF42S/IMG_0415.jpg',
  avatarPosition: 'object-[20%_35%]'
}, {
  name: 'Liliana Rodriguez',
  role: 'Cliente Verificada',
  content: 'Gracias a la asesoria de Edu, logre obtener hasta 40.000 dolares en mi primera tarjeta de credito de negocios con Chase, increible resultado, mi consejo? Dejense guiar del mejor.',
  avatar: 'https://cdn.magicpatterns.com/uploads/6Eiyt6b2wk5nugeq5wJ1Eh/IMG_0818.jpg'
}, {
  name: 'Edgar Morales',
  role: 'Cliente Verificado',
  content: 'Tenia 7 collections en mi reporte de credito y Eduardo y su equipo las removieron todas en menos de 60 dias, un resultado increible, me sorprendio, se los recomiendo a todos.',
  avatar: 'https://cdn.magicpatterns.com/uploads/4rr4pee8LoLBE4Rgz6MsKS/IMG_0819.jpg'
}, {
  name: 'Leonardo Cuello',
  role: 'Propietario de Casa',
  content: 'No podia comprar mi casa hasta que Eduardo y el equipo de vantix me ayudaron, literalmente no podia cerrar el negocio porque mi puntaje no estaba bien, ya luego lo arreglamos y voy por mi segunda casa ahora.',
  avatar: 'https://cdn.magicpatterns.com/uploads/gwsbtdrRTYn5J3CCGfeR2z/IMG_0820.jpg'
}, {
  name: 'Juan Soto',
  role: 'Cliente Verificado',
  content: 'Atencion excelente, recomendados al 100%.',
  avatar: 'https://cdn.magicpatterns.com/uploads/tjQxQtsc2cSbqyDTqq7foW/IMG_0821.jpg'
}];
export function Reviews() {
  return <section className="py-32 bg-black px-4 sm:px-6 lg:px-8 border-t border-white/5 relative overflow-hidden" data-id="element-197" data-mp="1m4up1m0jhz2j">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-198" data-mp="1r3fm5ckhw2mr" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-199" data-mp="1cdi65jwpyj8n">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20" data-id="element-200" data-mp="1hdw6sgvzqqwn">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-201" data-mp="ygl56pmvzle1">
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-202" data-mp="2nv9jwxiy9ff8">
              Resultados Reales
            </span>{' '}
            de Personas Reales
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-203" data-mp="c7eaqpbqzd40">
            Mira lo que sucede cuando dejas de esperar y tomas accion con
            Vantix.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-204" data-mp="m528lo4nh0qe">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: index % 3 * 0.1,
          ease: [0.16, 1, 0.3, 1]
        }} className="relative flex flex-col p-8 rounded-3xl bg-zinc-950 border border-white/[0.08] hover:border-amber-500/20 transition-all duration-500" data-id="element-205" data-mp="zvnu7klhnorz" data-mpi={index}>
              {/* Top row: stars + quote icon */}
              <div className="flex items-start justify-between mb-6" data-id="element-206" data-mp="3d1u8wekth0ov">
                <div className="flex gap-1" data-id="element-207" data-mp="3i3td1qods1mv">
                  {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-208" data-mp="3n0tji2p576ei" data-mpi={i} />)}
                </div>
                <Quote className="h-8 w-8 text-amber-500/15 fill-amber-500/10" data-id="element-209" data-mp="2uce7zq57z67x" />
              </div>

              {/* Quote */}
              <p className="italic text-white/60 font-light leading-relaxed text-[15px] mb-8 flex-grow" data-id="element-210" data-mp="2zaphu0vilgq5">
                "{review.content}"
              </p>

              {/* Divider */}
              <div className="h-px w-full bg-white/[0.08] mb-6" data-id="element-211" data-mp="26mtlix9uxqtw" />

              {/* Author */}
              <div className="flex items-center gap-3" data-id="element-212" data-mp="2blekyuhac6ha">
                <div className="h-11 w-11 rounded-full bg-gradient-to-br from-zinc-700 to-zinc-900 border border-white/10 flex items-center justify-center text-white font-semibold text-sm shrink-0 overflow-hidden" data-id="element-213" data-mp="srbgnbr0j7aa">
                  {review.avatar ? <img src={review.avatar} alt={review.name} className={`h-full w-full object-cover ${review.avatarPosition ?? ''}`} data-id="element-214" data-mp="jpc0smrqi98x" /> : review.name.split(' ').map(n => n[0]).slice(0, 2).join('')}
                </div>
                <div data-id="element-215" data-mp="3s78bzyy5y211">
                  <div className="text-white font-semibold leading-tight" data-id="element-216" data-mp="3s7zxui1ykle4">
                    {review.name}
                  </div>
                  <div className="text-sm text-white/40" data-id="element-217" data-mp="3n9q0c0srh8pc">{review.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}